import validator from "validator";
import message from "../../../messages/marketer/checkout";

const validateBankCardNumber = (bankAccountCardNumber) => {
  if (validator.isEmpty(bankAccountCardNumber)) {
    return message.BANK_ACCOUNT_CARD_NUMBER_INVALID;
  }

  if (!bankAccountCardNumber.trim()) {
    return message.BANK_ACCOUNT_CARD_NUMBER_INVALID;
  }

  if (bankAccountCardNumber.length != 19) {
    return message.BANK_ACCOUNT_CARD_NUMBER_INVALID;
  }

  return true;
};

const validateAmount = (amount, wallet) => {
  if (
    amount <
    parseInt(process.env.REACT_APP_AT_LEAST_AMOUNT_ASK_CHECK_OUT_MARKETER)
  ) {
    return message.AMOUNT_IS_LESS_THAN_AT_LEAST_AMOUNT_TRANSACTION;
  }

  if (wallet < amount) {
    return message.AMOUNT_IS_MORE_THAN_AMOUNT_USER_CAN_ASK_TRANSACTION;
  }

  return true;
};

const validateFormAddCheckOut = (info) => {
  const resValidateBankCardNumber = validateBankCardNumber(
    info.account_cart_number
  );

  if (resValidateBankCardNumber != true) {
    return resValidateBankCardNumber;
  }

  const resValidateAmount = validateAmount(info.amount, info.wallet);
  if (resValidateAmount != true) {
    return resValidateAmount;
  }

  return true;
};

export default validateFormAddCheckOut;
